<template>
  <div class="pagination-wrap">
    <ul class="page-list">
      <li @click="changePage(currentPage - 1)" class="btn-prev" :class="currentPage == 1 ? 'disabled' : ''">上一页</li>
      <li :class="{ active: currentPage == item.val }" v-for="item in pagelist" :key="item.text" v-text="item.text" @click="changePage(item.val)">1</li>
      <li @click="changePage(currentPage + 1)" class="btn-next" :class="currentPage == totalPage ? 'disabled' : ''">下一页</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    name: String,
    pageSize: {
      type: Number,
      default: 10,
    },
    total: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      pageGroup: 10, //可见分页数量 默认10个分页数
    }
  },
  computed: {
    totalPage: function() {
      return Math.ceil(this.total / this.pageSize)
    },
    pagelist: function() {
      var list = []
      var count = Math.floor(this.pageGroup / 2),
        center = this.currentPage
      var left = 1,
        right = this.totalPage
      if (this.totalPage > this.pageGroup) {
        if (this.currentPage > count + 1) {
          if (this.currentPage < this.totalPage - count) {
            left = this.currentPage - count
            right = this.currentPage + count - 1
          } else {
            left = this.totalPage - this.pageGroup + 1
          }
        } else {
          right = this.pageGroup
        }
      }
      // 遍历添加到数组里
      while (left <= right) {
        list.push({
          text: left,
          val: left,
        })
        left++
      }
      return list
    },
  },
  methods: {
    changePage: function(idx) {
      if (idx != this.currentPage && idx > 0 && idx <= this.totalPage) {
        this.$emit('change', { curPage: Number(idx) })
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.pagination-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  .page-list {
    width: 100%;
    text-align: center;
    margin: 0 auto;
    li {
      display: inline-block;
      padding: 0;
      margin-right: 10px;
      width: 40px;
      height: 30px;
      line-height: 28px;
      color: #333;
      font-weight: 400;
      border: 1px solid #e2e2e2;
      border-radius: 0;
      box-sizing: border-box;
      cursor: pointer;
      font-size: 12px;
      &.active {
        border-color: #2b99ff;
        background-color: #fff;
        color: #2b99ff;
      }
      &.disabled {
        background-color: #fff;
        cursor: not-allowed;
        color: #e2e2e2;
      }
      &.btn-prev,
      &.btn-next {
        width: 75px;
        height: 30px;
        border: 1px solid #e2e2e2;
        border-radius: 0;
      }
      &.btn-next {
        margin: 0;
      }
    }
  }
}
</style>
